import LecturePage from "../../features/dashboard/lecture/LecturePage";

function LectureDB() {
  return <LecturePage />;
}

export default LectureDB;
